export function campaignCodeCheck(campaignCode, callback) {
	return {
    type: 'CAMPAIGN_CODE_CHECK',
    payload: {
      campaignCode: campaignCode,
		},
    callback: callback,
	}
};


export function campaignSubmit(campaignCode, callback) {
	return {
    type: 'CAMPAIGN_SUBMIT',
    payload: {
      campaignCode: campaignCode,
		},
    callback: callback,
	}
};
